import { Stack } from '@mui/material'
import { PropsWithChildren, ReactNode } from 'react'

type ViolationContainerProps = PropsWithChildren<{
  violation?: ReactNode
}>

export function ViolationContainer(props: ViolationContainerProps) {
  const { children, violation } = props
  return (
    <Stack sx={{ gap: 1, flexDirection: 'row' }} component="div">
      <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 1, flexGrow: 1 }}>
        {children}
      </Stack>
      {violation}
    </Stack>
  )
}
